var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIconHelp = function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE9A8",
    d: "M11 20.625a9.625 9.625 0 1 0 0-19.25 9.625 9.625 0 0 0 0 19.25"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#330E07",
    strokeLinecap: "round",
    strokeWidth: 2.2,
    d: "M8.433 8.525a2.658 2.658 0 0 1 5.134.917c0 1.741-2.567 2.2-2.567 3.85"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#330E07",
    d: "M11 17.692a1.192 1.192 0 1 0 0-2.384 1.192 1.192 0 0 0 0 2.384"
  })));
};
export default SvgIconHelp;